import roles from '@/constants/roles';
import clientRoles from '@/constants/clientRoles';

export default Object.freeze([

    {
        title: 'sitePage.siteDashboard',
        path: { name: 'siteDashboard' },
        icon: 'SiteDashboard.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.siteTree',
        path: { name: 'siteTree' },
        icon: 'SiteTree.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.appointment',
        path: { name: 'siteAppointment' },
        icon: 'Calender.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.workOrdersTemplate',
        path: { name: 'siteWorkOrdersTemplate' },
        icon: 'WorkOrderTemplate.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.workOrders',
        path: { name: 'siteWorkOrders' },
        icon: 'WorkOrder.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.devices',
        path: { name: 'siteControllers' },
        icon: 'settings_remote.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.analysisRequest',
        path: { name: 'siteAnalysisRequest' },
        icon: 'SiteAnalysisRequest.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.reports',
        path: { name: 'siteReports' },
        icon: 'Reports.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.graphics',
        path: { name: 'graphics' },
        icon: 'Graphics.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.cart',
        path: { name: 'cart' },
        icon: 'Orders.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
        showItemNumber: true,
    },
    {
        title: 'sitePage.products',
        path: { name: 'siteProducts' },
        icon: 'Products.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.procedures',
        path: { name: 'siteProcedures' },
        icon: 'Procedures.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sites.document.title',
        path: { name: 'siteDocuments' },
        icon: 'Document.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.info',
        path: { name: 'siteInfo' },
        icon: 'SiteInfo.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.contacts',
        path: { name: 'siteContacts' },
        icon: 'Contacts.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'sitePage.alert',
        path: { name: 'siteAlerts' },
        icon: 'Alerts.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        title: 'clientPage.massBalance',
        path: { name: 'siteMassBalance' },
        icon: 'MassBalance.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
        ],
    },
    {
        title: 'sitePage.logs',
        path: { name: 'siteLogs' },
        icon: 'Logs.svg',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
        ],
    },
]);
